const SET_BRANCHES = 'SET_BRANCHES';

export { SET_BRANCHES };
